module.exports = __webpack_public_path__ + "img/news2-1.6bd2f81e.png";